import { render, staticRenderFns } from "./StarshipsPage.vue?vue&type=template&id=689f359f&lang=pug&"
import script from "./StarshipsPage.vue?vue&type=script&lang=ts&"
export * from "./StarshipsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports